import {
  MULTIPLE_ATTEMPT_SCORING,
  multipleAttemptScoringOptions,
} from '@edulastic/constants/const/test'

export const getMultipleAttemptScoringValue = (multipleAttemptScoring) =>
  multipleAttemptScoring || MULTIPLE_ATTEMPT_SCORING.LATEST

export const getMultipleAttemptScoringOptions = (i18translate) =>
  multipleAttemptScoringOptions.map((option) => ({
    ...option,
    label: i18translate(`multipleAttemptScoring.${option.value.toLowerCase()}`),
  }))
